var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import React, { useState, useEffect, useMemo, useRef } from 'react';
import { DataTable } from 'primereact/datatable';
import { Column } from 'primereact/column';
import { Button } from 'primereact/button';
import { Dialog } from 'primereact/dialog';
import { InputText } from 'primereact/inputtext';
import { InputNumber } from 'primereact/inputnumber';
import { Calendar } from 'primereact/calendar';
import { Dropdown } from 'primereact/dropdown';
import { Toast } from 'primereact/toast';
import { confirmDialog } from 'primereact/confirmdialog';
import { apiService } from '../utils/api';
import { formatINR } from '../utils/currencyUtils';
import { formatDateForUI } from '../utils/dateUtils';
import MdlPaginatorLeft from '../components/MdlPaginatorLeft';
import '../styles/masterListView.css';
import { pillValue } from '../utils/mdlPill';
var Bills = function () {
    var _a = useState([]), bills = _a[0], setBills = _a[1];
    var _b = useState([]), members = _b[0], setMembers = _b[1];
    var _c = useState(null), selectedBill = _c[0], setSelectedBill = _c[1];
    var _d = useState(false), dialogVisible = _d[0], setDialogVisible = _d[1];
    var _e = useState(false), isNew = _e[0], setIsNew = _e[1];
    var _f = useState(true), loading = _f[0], setLoading = _f[1];
    var _g = useState(''), searchInput = _g[0], setSearchInput = _g[1];
    var _h = useState(''), globalFilter = _h[0], setGlobalFilter = _h[1];
    var _j = useState(null), typeFilter = _j[0], setTypeFilter = _j[1];
    var _k = useState(null), statusFilter = _k[0], setStatusFilter = _k[1];
    var _l = useState(0), first = _l[0], setFirst = _l[1];
    var _m = useState(12), rows = _m[0], setRows = _m[1];
    var toast = useRef(null);
    var billTypes = [
        { label: 'Savings', value: 'SAVINGS' },
        { label: 'Loan', value: 'LOAN' },
        { label: 'Interest', value: 'INTEREST' }
    ];
    var billStatuses = [
        { label: 'Pending', value: 'PENDING' },
        { label: 'Paid', value: 'PAID' },
        { label: 'Overdue', value: 'OVERDUE' }
    ];
    useEffect(function () {
        fetchBills();
        fetchMembers();
    }, []);
    useEffect(function () {
        var debounce = setTimeout(function () { return setGlobalFilter(searchInput); }, 300);
        return function () { return clearTimeout(debounce); };
    }, [searchInput]);
    useEffect(function () {
        setFirst(0);
    }, [globalFilter, typeFilter, statusFilter]);
    var fetchBills = function () { return __awaiter(void 0, void 0, void 0, function () {
        var response, error_1;
        var _a, _b;
        return __generator(this, function (_c) {
            switch (_c.label) {
                case 0:
                    setLoading(true);
                    _c.label = 1;
                case 1:
                    _c.trys.push([1, 3, 4, 5]);
                    return [4 /*yield*/, apiService.get('/bills')];
                case 2:
                    response = _c.sent();
                    if (response.success) {
                        setBills(response.data || []);
                    }
                    else {
                        (_a = toast.current) === null || _a === void 0 ? void 0 : _a.show({ severity: 'error', summary: 'Error', detail: response.error || 'Failed to fetch bills' });
                    }
                    return [3 /*break*/, 5];
                case 3:
                    error_1 = _c.sent();
                    console.error('Error fetching bills:', error_1);
                    (_b = toast.current) === null || _b === void 0 ? void 0 : _b.show({ severity: 'error', summary: 'Error', detail: 'Failed to fetch bills' });
                    return [3 /*break*/, 5];
                case 4:
                    setLoading(false);
                    return [7 /*endfinally*/];
                case 5: return [2 /*return*/];
            }
        });
    }); };
    var fetchMembers = function () { return __awaiter(void 0, void 0, void 0, function () {
        var response, error_2;
        var _a, _b;
        return __generator(this, function (_c) {
            switch (_c.label) {
                case 0:
                    _c.trys.push([0, 2, , 3]);
                    return [4 /*yield*/, apiService.get('/members/slim')];
                case 1:
                    response = _c.sent();
                    if (response.success) {
                        setMembers((response.data || []).map(function (member) { return ({
                            label: member.cpdNo ? "".concat(member.cpdNo, " \u2014 ").concat(member.name) : member.name,
                            value: member.id
                        }); }));
                    }
                    else {
                        (_a = toast.current) === null || _a === void 0 ? void 0 : _a.show({ severity: 'error', summary: 'Error', detail: response.error || 'Failed to fetch members' });
                    }
                    return [3 /*break*/, 3];
                case 2:
                    error_2 = _c.sent();
                    console.error('Error fetching members:', error_2);
                    (_b = toast.current) === null || _b === void 0 ? void 0 : _b.show({ severity: 'error', summary: 'Error', detail: 'Failed to fetch members' });
                    return [3 /*break*/, 3];
                case 3: return [2 /*return*/];
            }
        });
    }); };
    var handleSave = function () { return __awaiter(void 0, void 0, void 0, function () {
        var response, error_3;
        var _a, _b, _c;
        return __generator(this, function (_d) {
            switch (_d.label) {
                case 0:
                    _d.trys.push([0, 5, , 6]);
                    response = void 0;
                    if (!isNew) return [3 /*break*/, 2];
                    return [4 /*yield*/, apiService.post('/bills', selectedBill)];
                case 1:
                    response = _d.sent();
                    return [3 /*break*/, 4];
                case 2: return [4 /*yield*/, apiService.put("/bills/".concat(selectedBill === null || selectedBill === void 0 ? void 0 : selectedBill.id), selectedBill)];
                case 3:
                    response = _d.sent();
                    _d.label = 4;
                case 4:
                    if (response.success) {
                        (_a = toast.current) === null || _a === void 0 ? void 0 : _a.show({ severity: 'success', summary: 'Success', detail: "Bill ".concat(isNew ? 'created' : 'updated', " successfully!") });
                        setDialogVisible(false);
                        fetchBills();
                    }
                    else {
                        (_b = toast.current) === null || _b === void 0 ? void 0 : _b.show({ severity: 'error', summary: 'Error', detail: response.error || 'Failed to save bill' });
                    }
                    return [3 /*break*/, 6];
                case 5:
                    error_3 = _d.sent();
                    console.error('Error saving bill:', error_3);
                    (_c = toast.current) === null || _c === void 0 ? void 0 : _c.show({ severity: 'error', summary: 'Error', detail: 'An error occurred while saving' });
                    return [3 /*break*/, 6];
                case 6: return [2 /*return*/];
            }
        });
    }); };
    var handleDelete = function (id) { return __awaiter(void 0, void 0, void 0, function () {
        return __generator(this, function (_a) {
            confirmDialog({
                message: 'Are you sure you want to delete this bill?',
                header: 'Delete Confirmation',
                icon: 'pi pi-exclamation-triangle',
                accept: function () { return __awaiter(void 0, void 0, void 0, function () {
                    var response, error_4;
                    var _a, _b, _c;
                    return __generator(this, function (_d) {
                        switch (_d.label) {
                            case 0:
                                _d.trys.push([0, 2, , 3]);
                                return [4 /*yield*/, apiService.delete("/bills/".concat(id))];
                            case 1:
                                response = _d.sent();
                                if (response.success) {
                                    (_a = toast.current) === null || _a === void 0 ? void 0 : _a.show({ severity: 'success', summary: 'Success', detail: 'Bill deleted successfully!' });
                                    fetchBills();
                                }
                                else {
                                    (_b = toast.current) === null || _b === void 0 ? void 0 : _b.show({ severity: 'error', summary: 'Error', detail: response.error || 'Failed to delete bill' });
                                }
                                return [3 /*break*/, 3];
                            case 2:
                                error_4 = _d.sent();
                                (_c = toast.current) === null || _c === void 0 ? void 0 : _c.show({ severity: 'error', summary: 'Error', detail: 'An error occurred while deleting' });
                                return [3 /*break*/, 3];
                            case 3: return [2 /*return*/];
                        }
                    });
                }); }
            });
            return [2 /*return*/];
        });
    }); };
    var actionBodyTemplate = function (rowData) { return (_jsxs("div", __assign({ className: "mdl-action-group" }, { children: [_jsx("button", __assign({ type: "button", className: "mdl-icon-btn", "aria-label": "Edit bill", title: "Edit", onClick: function () { setSelectedBill(rowData); setIsNew(false); setDialogVisible(true); } }, { children: _jsx("i", { className: "pi pi-pencil" }) })), _jsx("button", __assign({ type: "button", className: "mdl-icon-btn danger", "aria-label": "Delete bill", title: "Delete", onClick: function () { return handleDelete(rowData.id); } }, { children: _jsx("i", { className: "pi pi-trash" }) }))] }))); };
    var memberLabelById = useMemo(function () { return new Map(members.map(function (m) { return [m.value, m.label]; })); }, [members]);
    var memberName = function (b) { return memberLabelById.get(b.memberId) || ''; };
    var labelOf = function (opts, v) { var _a; return ((_a = opts.find(function (o) { return o.value === v; })) === null || _a === void 0 ? void 0 : _a.label) || v; };
    var term = globalFilter.trim().toLowerCase();
    var filteredBills = bills.filter(function (b) {
        return (!typeFilter || b.type === typeFilter) &&
            (!statusFilter || b.status === statusFilter) &&
            (!term || String(b.id).includes(term) || memberName(b).toLowerCase().includes(term));
    });
    var hasFilters = !!(globalFilter || typeFilter || statusFilter);
    return (_jsxs("div", __assign({ className: "card mdl-page" }, { children: [_jsx(Toast, { ref: toast }), _jsxs("div", __assign({ className: "mdl-page-header" }, { children: [_jsxs("div", { children: [_jsx("h1", __assign({ className: "mdl-page-title" }, { children: "Bills Management" })), _jsxs("p", __assign({ className: "mdl-page-subtitle" }, { children: [bills.length, " bill", bills.length === 1 ? '' : 's'] }))] }), _jsx("div", __assign({ className: "mdl-page-actions" }, { children: _jsx(Button, { label: "Add Bill", icon: "pi pi-plus", className: "mdl-btn-primary", onClick: function () {
                                setSelectedBill({
                                    id: 0,
                                    memberId: 0,
                                    amount: 0,
                                    date: new Date(),
                                    type: 'SAVINGS',
                                    status: 'PENDING'
                                });
                                setIsNew(true);
                                setDialogVisible(true);
                            } }) }))] })), _jsxs("div", __assign({ className: "mdl-toolbar" }, { children: [_jsxs("span", __assign({ className: "p-input-icon-left mdl-search" }, { children: [_jsx("i", { className: "pi pi-search" }), _jsx(InputText, { placeholder: "Search bill ID or member", value: searchInput, onChange: function (e) { return setSearchInput(e.target.value); }, className: "mdl-search-input" })] })), _jsxs("div", __assign({ className: "mdl-toolbar-filters" }, { children: [_jsx(Dropdown, { value: typeFilter, options: billTypes, onChange: function (e) { return setTypeFilter(e.value); }, placeholder: "Type: All", valueTemplate: pillValue('Type'), showClear: true, className: "mdl-filter-pill".concat(typeFilter ? ' applied' : '') }), _jsx(Dropdown, { value: statusFilter, options: billStatuses, onChange: function (e) { return setStatusFilter(e.value); }, placeholder: "Status: All", valueTemplate: pillValue('Status'), showClear: true, className: "mdl-filter-pill".concat(statusFilter ? ' applied' : '') })] }))] })), _jsxs(DataTable, __assign({ value: filteredBills, loading: loading, paginator: true, first: first, rows: rows, onPage: function (e) { setFirst(e.first); setRows(e.rows); }, removableSort: true, className: "p-datatable-sm mdl-table-header mdl-table-footer", paginatorLeft: _jsx(MdlPaginatorLeft, { id: "bills-rows-per-page", first: first, rows: rows, total: filteredBills.length, onRowsChange: function (r) { setRows(r); setFirst(0); } }), paginatorTemplate: "FirstPageLink PrevPageLink PageLinks NextPageLink LastPageLink", emptyMessage: hasFilters ? 'No bills match your filters' : 'No bills yet' }, { children: [_jsx(Column, { field: "id", header: "ID", headerClassName: "mdl-col-numeric", bodyClassName: "mdl-col-numeric", style: { width: '80px' }, sortable: true }), _jsx(Column, { field: "memberId", header: "Member", body: function (b) { return _jsx("span", __assign({ className: "mdl-name-cell" }, { children: memberName(b) })); }, sortable: true }), _jsx(Column, { field: "amount", header: "Amount", body: function (b) { return formatINR(b.amount); }, headerClassName: "mdl-col-numeric", bodyClassName: "mdl-col-numeric", sortable: true }), _jsx(Column, { field: "date", header: "Date", body: function (b) { return formatDateForUI(b.date); }, sortable: true }), _jsx(Column, { field: "type", header: "Type", body: function (b) { return labelOf(billTypes, b.type); }, sortable: true }), _jsx(Column, { field: "status", header: "Status", body: function (b) { return labelOf(billStatuses, b.status); }, sortable: true }), _jsx(Column, { body: actionBodyTemplate, header: "Actions", headerClassName: "mdl-col-numeric", style: { width: '110px' } })] })), _jsxs(Dialog, __assign({ visible: dialogVisible, onHide: function () { return setDialogVisible(false); }, header: isNew ? 'Add New Bill' : 'Edit Bill', modal: true, className: "p-fluid", footer: _jsxs("div", { children: [_jsx(Button, { label: "Cancel", icon: "pi pi-times", onClick: function () { return setDialogVisible(false); }, className: "p-button-text" }), _jsx(Button, { label: "Save", icon: "pi pi-check", onClick: handleSave, className: "p-button-primary" })] }) }, { children: [_jsxs("div", __assign({ className: "field" }, { children: [_jsx("label", __assign({ htmlFor: "memberId" }, { children: "Member" })), _jsx(Dropdown, { id: "memberId", value: selectedBill === null || selectedBill === void 0 ? void 0 : selectedBill.memberId, options: members, onChange: function (e) { return setSelectedBill(__assign(__assign({}, selectedBill), { memberId: e.value })); }, filter: true, filterBy: "label", virtualScrollerOptions: { itemSize: 38 }, placeholder: "Search by CPD no or name", required: true })] })), _jsxs("div", __assign({ className: "field" }, { children: [_jsx("label", __assign({ htmlFor: "amount" }, { children: "Amount" })), _jsx(InputNumber, { id: "amount", value: selectedBill === null || selectedBill === void 0 ? void 0 : selectedBill.amount, onValueChange: function (e) { return setSelectedBill(__assign(__assign({}, selectedBill), { amount: e.value || 0 })); }, mode: "currency", currency: "INR", locale: "en-IN", required: true })] })), _jsxs("div", __assign({ className: "field" }, { children: [_jsx("label", __assign({ htmlFor: "date" }, { children: "Date" })), _jsx(Calendar, { id: "date", value: selectedBill === null || selectedBill === void 0 ? void 0 : selectedBill.date, onChange: function (e) { return setSelectedBill(__assign(__assign({}, selectedBill), { date: e.value })); }, dateFormat: "dd/mm/yy", required: true })] })), _jsxs("div", __assign({ className: "field" }, { children: [_jsx("label", __assign({ htmlFor: "type" }, { children: "Type" })), _jsx(Dropdown, { id: "type", value: selectedBill === null || selectedBill === void 0 ? void 0 : selectedBill.type, options: billTypes, onChange: function (e) { return setSelectedBill(__assign(__assign({}, selectedBill), { type: e.value })); }, placeholder: "Select Type", required: true })] })), _jsxs("div", __assign({ className: "field" }, { children: [_jsx("label", __assign({ htmlFor: "status" }, { children: "Status" })), _jsx(Dropdown, { id: "status", value: selectedBill === null || selectedBill === void 0 ? void 0 : selectedBill.status, options: billStatuses, onChange: function (e) { return setSelectedBill(__assign(__assign({}, selectedBill), { status: e.value })); }, placeholder: "Select Status", required: true })] }))] }))] })));
};
export default Bills;
